//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: "science",
    data() {
        return {
            list: [],
            id: '',
            nodeId: '',
            downloadUrl: util.ApiUrl + 'file/download/',
            title: ''
        }
    },
    methods: {
        getContentByNodeName() {
            abp.ajax.get('/api/services/app/Content/GetAllContentByName?name=' + this.title).then((res) => {
                //console.log(this.title);
                var list = res.data.result;

                if (list.length > 0) {
                    //console.log(list);
                    /*this.getGraphicInformationByBusiness(list[0].id)*/
                    this.list.push(...res.data.result);
                }
            });
        },
        getGraphicInformationByBusiness(id) {
            abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessId=' + id + '&businessType=content.remarks').then(res => {
                this.content = [];
                this.content = res.data.result;
                // console.log(res.data);
            })
        },
        listClicked(list) {
            if (list.contentType === 0) {
                this.$router.push('/serveMsgDetail/' + list.id);
            } else if (list.contentType === 1 && list.source != null) {
                if (list.source.substr(0, 8) === 'https://') {
                    window.open(list.source);
                } else {
                    window.open('https://' + list.source);
                }
            } else {
                this.$router.push('/serveMsgDetail/' + list.id);
            }

        },
    },
    created() {
        this.title = this.$route.params.title
        this.getContentByNodeName();

    }
}
